export const LOAD_INFRASTRUKTURSTATI = 'load_infrastrukturstati';
export const LOAD_INFRASTRUKTURSUBSTATI = 'load_infrastruktursubstati';
export const LOAD_INFRASTRUKTURTYPEN = 'load_infrastrukturtypen';
export const LOAD_INFRASTRUKTURGRUPPEN = 'load_infrastrukturgruppen';

export const LOAD_STANDORTE = 'load_standorte';
export const LOAD_KATEGORIEN = 'load_kategorien';

export const LOAD_ANZAHL_INFRASTRUKTUR = 'load_anzahl_infrastruktur';
